import { getImageConfig } from "@website-builder/utilities-index";

export default (props, { basicConfig }) => {
	const { blogBannerImage, blogBannerImageMobile } = props;
	const bannerConfig = getImageConfig(blogBannerImage, basicConfig);
	const mobileBannerConfig = getImageConfig(blogBannerImageMobile, basicConfig);
	return {
		bannerConfig,
		mobileBannerConfig,
	};
};
